'use strict';

( function ( $ ) {
	const $loginModal = $( '#modal-login' );
	if ( $loginModal.length ) {
		initLoginModal();
		showLoginModal(); // Show modal immediately
	}

	// Initialize login modal functionality
	function initLoginModal() {
		const $closeButton = $loginModal.find( '.modal-login__close' );

		// Handle close button click
		$closeButton.on( 'click', function () {
			closeLoginModal( $loginModal );
		} );

		// Handle overlay click (close when clicking outside modal)
		$loginModal.on( 'click', function ( e ) {
			if ( $( e.target ).hasClass( 'modal-login__overlay' ) ) {
				closeLoginModal( $loginModal );
			}
		} );
	}

	// Helper function to show modal
	function showLoginModal() {
		$loginModal.fadeIn( '100' );
		$( 'body' ).css( 'overflow', 'hidden' );
	}

	// Helper function to close modal
	function closeLoginModal( $modal ) {
		$modal.fadeOut( '100' );
		$( 'body' ).css( 'overflow', 'auto' );
	}
} )( jQuery );
